import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import tierList from "../imgs/tier-list-example.png";
import Image from "material-ui-image";
import SignUpForm from "../components/SignUpForm";
import { Typography } from "@mui/material";


function SignUp() {
  return (
    <main
      style={{
        minHeight: "calc(100vh - 56px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container>
        <Grid container gap={2}>
          <Grid item xs={12} md={6} lg={8}>
            <Typography
              component="h1"
              variant="h3"
              className="text-align-center"
            >
              New To Tier List Creator?
            </Typography>
            <Box sx={{ width: "300px", margin: "auto" }}>
              <Image src={tierList} alt="" />
            </Box>
            <p className="text-align-center">
              Thanks for visiting! Sign up to interact and create.
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md
            lg
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <SignUpForm />
          </Grid>
        </Grid>
      </Container>
    </main>
  );
}

export default SignUp;
